module.exports = __webpack_public_path__ + "static/media/coming-soon.bae18713.jpg";